import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Action, Store} from '@ngrx/store';
import {ROUTER_NAVIGATED} from '@ngrx/router-store';
import {filter, map, withLatestFrom} from 'rxjs';
import {QueryParamsActions} from './query-params.actions';
import {RouterSelectors} from '@aviary/store/router/router.selectors';

// eslint-disable-next-line @angular-eslint/use-injectable-provided-in -- This is registered via NgRx; it's not an Angular tree-shakable provider.
@Injectable()
export class QueryParamsEffects {

  private readonly store: Store = inject(Store);
  private readonly actions: Actions = inject(Actions);

  public saveQueryParamsOnRouterNavigated = createEffect(() =>
    this.actions.pipe(
      ofType<Action>(ROUTER_NAVIGATED),
      withLatestFrom(
        this.store.select(RouterSelectors.routeName),
        this.store.select(RouterSelectors.queryParams)
      ),
      filter(([, routeName]) => !!routeName),
      map(([, routeName, queryParams]) =>
        QueryParamsActions.save(routeName as string, queryParams)
      )
    )
  );
}
